:root ._dsp-flex{display:flex;}
:root ._fd-column{flex-direction:column;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._height-t-size-larg101{height:var(--t-size-large);}
:root ._width-10037{width:100%;}
:root ._items-center{align-items:center;}
:root ._justify-center{justify-content:center;}
:root ._pos-relative{position:relative;}
:root ._cur-pointer{cursor:pointer;}
:root ._o-0--3{opacity:0.3;}
:root ._o-1{opacity:1;}
:root ._pos-absolute{position:absolute;}
:root ._t-0px{top:0px;}
:root ._b-0px{bottom:0px;}
:root ._l-0px{left:0px;}
:root ._r-0px{right:0px;}
:root ._z-0{z-index:0;}
:root ._btlr-100000px{border-top-left-radius:100000px;}
:root ._btrr-100000px{border-top-right-radius:100000px;}
:root ._bbrr-100000px{border-bottom-right-radius:100000px;}
:root ._bblr-100000px{border-bottom-left-radius:100000px;}
:root ._pt-0px{padding-top:0px;}
:root ._pr-0px{padding-right:0px;}
:root ._pb-0px{padding-bottom:0px;}
:root ._pl-0px{padding-left:0px;}
:root ._bg-e9f9ee35{background-color:#e9f9ee;}
:root ._width-t-size-medi3736{width:var(--t-size-medium);}
:root ._height-t-size-medi3736{height:var(--t-size-medium);}
:root ._items-stretch{align-items:stretch;}
:root ._t-2px{top:2px;}
:root ._r-5px{right:5px;}
:root ._b-3px{bottom:3px;}